import axiosInstance from '../plugin/axios';

interface FetchInquiryListParams {
  startDate: string;
  endDate: string;
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface InquiryListResponseData {
  inquiryId: number;
  title: string;
  createdAt: string;
  state: string;
}

interface InquiryDto {
  title: string;
  question: string;
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

interface InquiryDetailDtoRx {
  passid: string;
  phone: string;
  createdAt: string;
  title: string;
  question: string;
  answer: string;
}

interface UpdateInquiryDto {
  title: string;
  question: string;
}

export const fetchInquiryList = async (
  params: FetchInquiryListParams,
): Promise<InquiryListResponseData[]> => {
  console.log('params:', params);
  try {
    const {
      startDate,
      endDate,
      offset = 0,
      limit = 1000,
      sortBy = 'createdAt',
      order = 'desc',
    } = params;

    const response = await axiosInstance.get<InquiryListResponseData[]>(
      '/api/inquiry',
      {
        params: {
          startDate,
          endDate,
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('문의사항 데이터를 불러오는 데 실패했습니다.', error);
    throw new Error('문의사항 데이터를 불러오는 데 실패했습니다.');
  }
};

export const inquiryRagistration = async (
  inquiryData: InquiryDto,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/inquiry/registration`,
      inquiryData,
    );
    return response.data;
  } catch (error: any) {
    console.error('Error duplication:', error?.response?.data || error.message);
    throw error;
  }
};

export const fetchInquiryDetail = async (inquiryId: number) => {
  try {
    const response = await axiosInstance.get<InquiryDetailDtoRx>(
      `/api/inquiry/registration/${inquiryId}`,
    );
    return response.data; // 서버로부터 받은 데이터를 반환
  } catch (error) {
    console.error('Error fetching driver detail:', error);
    throw error; // 에러 발생 시 에러를 반환
  }
};

export const updateInquiry = async (
  inquiryId: number,
  data: UpdateInquiryDto,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.put<ServerResponse>(
      `/api/inquiry/registration/${inquiryId}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching driver detail:', error);
    throw error; // 에러 발생 시 에러를 반환
  }
};
